import { Routes } from '@angular/router';

import {LoginComponent} from './auth/login/login.component';
import {RegisterComponent} from './auth/register/register.component';
import {AffairesListComponent} from './affaires/affaires-list/affaires-list.component';
import {LogoutComponent} from './auth/logout/logout.component';
import {AuthGuard} from './guards/auth.guard';
import {NoAuthGuard} from './guards/noauth.guard';
import {LotsListComponent} from './lots/lots-list/lots-list.component';
import {AffaireDetailsComponent} from "./affaire/affaire-details/affaire-details.component";
import {ClientsListComponent} from "./clients-list/clients-list.component";
import {AdminGuard} from "./guards/admin.guard";
import {NewCommandComponent} from './new-command/new-command.component';
import {StatsComponent} from './stats/stats.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {path: '', component: LoginComponent, canActivate: [NoAuthGuard]},
  {path: 'register', component: RegisterComponent, canActivate: [NoAuthGuard]},
  {path: 'login', component: LoginComponent, canActivate: [NoAuthGuard]},

  {path: 'affaires/:id', component: AffairesListComponent, canActivate: [AuthGuard]},
  {path: 'affaire/:id', component: AffaireDetailsComponent, canActivate: [AuthGuard]},
  {path: 'new-command', component: NewCommandComponent, canActivate: [AuthGuard]},

  {path: 'lots', component: LotsListComponent, canActivate: [AuthGuard]},

  {path: 'clients', component: ClientsListComponent, canActivate: [AdminGuard]},
  {path: 'stats', component: StatsComponent, canActivate: [AuthGuard]},



  {path: 'logout', component: LogoutComponent, canActivate: [AuthGuard]},

  {path: '**', redirectTo: 'lots'}
];
